// Compiled and minified by Rollup into assets/built/index.js

import "../css/index.css";

import navToggle from "./navToggle";
import themeToggle from "./themeToggle";
import dateline from "./dateline";
import embeds from "./embeds";
import bookTitles from "./bookTitles";
import shelfSort from "./shelfSort";

navToggle();
themeToggle();
dateline();
embeds();
bookTitles();
shelfSort();
